<div id="book" #book width=100% height=100% style="z-index:900; position:absolute; background-size:cover; background-position:center; text-align:left" [innerHTML]="bookText" [ngStyle]="pageOpened ? bookOpenedStyle : bookStyle">
</div>
